import { DirectionalLight, HemisphereLight, PointLight, AmbientLight, Scene } from "three";

/**
 * @description 라이트들을 씬과 메모리에서 정리하는 함수
 * @param lights - 정리할 라이트 배열
 * @param scene - 씬
 */
export function cleanupLights(lights: (DirectionalLight | HemisphereLight | PointLight | AmbientLight)[], scene: Scene): void {
  lights.forEach(light => {
    // 라이트 dispose
    light.dispose();
    // 씬에서 제거
    scene.remove(light);
  });
}

/**
 * @description 환경맵을 씬과 메모리에서 정리하는 함수
 * @param scene - 씬
 */
export function cleanupEnvironment(scene: Scene): void {
  if (scene.environment) {
    // 환경맵 텍스처 dispose
    scene.environment.dispose();
    // 씬에서 환경맵 제거
    scene.environment = null;
  }

  if (scene.background) {
    // 배경이 텍스처인 경우에만 dispose
    if (typeof scene.background === 'object' && 'dispose' in scene.background) {
      scene.background.dispose();
    }
    // 씬에서 배경 제거
    scene.background = null;
  }
}
